import useLeagueSeason from "./useLeagueSeason";

export default function useSeason() {
  const { leagueSeason } = useLeagueSeason();

  let season = null;
  if (leagueSeason) {
    season = leagueSeason.obj.season;
  }

  return season;
}
